<template>
  <div v-if="!ishide">
    <div class="fx__item" style="display:flex;align-items:center;cursor: pointer;" @click="isfold=!isfold">
      <span class="arrow" :class="{rotate90:!isfold}" style="margin-left:5px;"><i class="fa fa-angle-right"></i></span>
      <span class="fx__text_middle" style="margin-left:5px;">{{Opts.text}}</span>

      <Icon v-if="loading" style="margin-left:5px;" type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <Badge v-else style="margin-left:5px;" :count="items.length"></Badge>
    </div>
    <ul v-if="!isfold">
      <li v-for="(item, index) in items" :key="index" class="fx__text_default fx__item lihref" @click="onClickItem(item)">
        {{item.text}}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    Opts: Object
  },
  inject: ["closeSearchDiv"],
  data() {
    return {
      isfold: true,
      loading: true,
      items: [],
      ishide: false
    };
  },
  mounted() {
    console.log("searchItem", this.Opts);
    let _this = this;
    let { url, keyword } = _this.Opts;

    _this.$curl.get(url, { keyword }).then(res => {
      _this.items = res;
      _this.Opts.count = res.length;
      _this.loading = false;
      _this.isfold = false;
      _this.ishide = this.items.length == 0;
    });
  },
  methods: {
    onClickItem(item) {
      this.closeSearchDiv();
      this.$router.push({ path: item.path });
    }
  }
};
</script>
<style lang="scss" scoped>
ul {
  list-style-type: none;
  li {
    padding-left: 20px;
  }
  .lihref {
    cursor: pointer;
  }
}
.rotate90 {
  transform: rotate(90deg);
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>